import React from 'react';

const AuthBackground = () => {
    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <img
                src="/assets/images/hubvex_africa_tech_map.png"
                alt=""
                className="
                    absolute 
                    w-[80%] max-w-3xl 
                    opacity-20 
                    select-none pointer-events-none
                    top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2
                    lg:top-1/2 lg:left-[10%] lg:translate-x-0 lg:-translate-y-1/2
                "
            />
        </div>
    );
};

export default AuthBackground;